<template>
  <div class="page_recruitDemand">
    <div class="talkBox flex">
      <ShowNavHead class="cp" style="margin:10px 0 0 5px;" />
      <!-- 看板 -->
      <div class="bulletinBoard">
        <div class="talkTop">
          <span class="talkTitle">沟通看板</span>
          <el-select ref="ProjectId" @change="selectPro" style="margin-left: 10px;" v-model="ProjectId" filterable clearable placeholder="请选择项目">
            <el-option v-for="item in prolist" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </div>  
        <div class="empty" v-if="(talktotal==0)">暂无沟通信息</div>
        <div v-show="(oneInfo.length>0)" class="infoBox" :class="ismore == false?'infoBox':'infoBox infoBox_all'" ref="talkinfo">
          <div v-for="(item,index) in oneInfo" :key="index" class="talkinfo_box">
            <div :class="item.isMoreShow == false?'talkinfo':'talkinfo talkinfo_all'">
              <span>【{{item.StrprojectName}}】</span>
              <span>{{item.StrCommunicate}}</span>
              <span style=" font-style:italic;font-weight:bold;font-size:13px;color:#999;"> —{{item.GduserName}}</span>
              <span class="talkTime" v-if="item.DtInserDate">，{{item.DtInserDate.replace('T',' ')}}</span>
              <span class="file cp" v-for="file in item.FileList" :key="file.Id" @click="downloadFile(file.Url)">
                <span>
                  <img v-if="file.Url.indexOf('.do') > -1" src="../../assets/images/word.png" alt="">
                  <img v-else-if="file.Url.indexOf('.pdf') > -1" src="../../assets/images/pdf.png" alt="">
                  <img v-else-if="file.Url.indexOf('.xl') > -1" src="../../assets/images/excel.png" alt="">
                  <img v-else src="../../assets/images/file.png" alt="">
                  {{file.FileName}}
                </span>
              </span>
            </div>
            <div v-if="item.isHas == true" class="talkinfo_right">
              <span @click="item.isMoreShow =!item.isMoreShow" class="s_more">{{item.isMoreShow == true?'收起':'展开'}}</span>
            </div>
          </div>
        </div>
        <div class="moreBtn flex">
          <span @click="ismore = false" v-show="ismore">收起</span>
          <span @click="ismore = true" v-show="(!ismore && oneInfo.length>0)">更多信息 >></span>
          <el-pagination v-show="ismore && talktotal>10" @current-change="handleCurrentChange" :current-page.sync="pageQuery.pageNum" :page-size="pageQuery.pageSize" layout="total,prev,pager, next, jumper" :total="talktotal"></el-pagination>
        </div>
      </div>
    </div>
    <div class="topOperation recruitTop">
      <div class="top-left">
        <div class="screenInputs recruitInputs">
          <div class="screenInput">
            <div class="flname">面试时间</div>
            <el-date-picker v-model="listQuery.interviewStartTime" :clearable="false" type="date" style="margin-left: 20px;" value-format="yyyy-MM-dd" placeholder="选择开始时间"></el-date-picker>
            <el-date-picker v-model="listQuery.interviewEndTime" :clearable="false" @change="seach()" type="date" style="margin-left: 20px;" value-format="yyyy-MM-dd" placeholder="选择结束时间"></el-date-picker>
          </div>
          <div class="screenInput">
            <div class="flname">项目</div>
            <el-select ref="ProjectId" @change="seach()" style="margin-left: 10px;" v-model="listQuery.ProjectId" filterable clearable placeholder="请选择项目">
              <el-option v-for="item in prolist" :key="item.key" :label="item.value" :value="item.key"></el-option>
            </el-select>
          </div>
          <div class="screenInput">
            <div class="flname">岗位类型</div>
            <el-cascader :options="jobCategoryList" clearable ref="cascader" :show-all-levels="false" v-model="listQuery.JobCategory" @change="changeJob" :props="{checkStrictly: true ,
              value:'strParametername',label:'strParametername'
            }"></el-cascader>
          </div>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="更多检索项" placement="top-start" v-if="userLabel!='K'">
              <i class="i_txt" @click="dropDownScreen">更多<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
            <el-button size="small" type="success" style="margin-left: 10px;" @click="seach()" v-if="showDropScreen==-1">搜索</el-button>
          </div>
        </div>
      </div>
      <div>
        <div>
        </div>
      </div>
      <div class="dropDownScreen" v-show="showDropScreen==1">
        <div class="pro_down_box">
          <el-form :inline="true" :model="listQuery" ref="recruitQuery" class="pro_down_form" label-width="120px">
            <el-form-item label="服务部门:">
              <el-cascader :props="deportProps" ref="deportCascader" clearable filterable :options="departList" :show-all-levels="false" @change="handleSectionChange"></el-cascader>
            </el-form-item>
            <el-form-item label="客服:">
              <el-select @change="selectChange" clearable v-model="listQuery.strservuserid" filterable placeholder="请选择">
                <el-option v-for="(item, index) in customerList" :key="index" :label="item.Username" :value="item.Strservuserid">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="工作城市:">
              <el-cascader :props="propsAddress" filterable ref="cascaderArr" clearable placeholder="" v-model="selected" :options="areaList" @change="changeAreaHandle"></el-cascader>
            </el-form-item>
            <!-- <el-form-item label="合伙人:">
              <el-select @change="selectChange" v-model="listQuery.strpartner2" filterable clearable placeholder="请选择">
                <el-option v-for="(item, index) in partnerList" :key="index" :label="item.Username" :value="item.Userid">
                </el-option>
              </el-select>
            </el-form-item> -->
            <!-- <el-form-item label="需求状态:">
              <el-select @change="selectChange" v-model="a" placeholder="请选择">
                <el-option label="餐厅名" value="1"></el-option>
              </el-select>
            </el-form-item> -->
            <!-- <el-form-item label="业务部门:">
              <el-cascader :props="deportProps" ref="deportCascader2" clearable filterable :options="departList" :show-all-levels="false" @change="perSectionChange"></el-cascader>
            </el-form-item> -->
            <!-- <el-form-item label="招聘部门:">
              <el-select @change="selectChange" v-model="a" placeholder="请选择">
                <el-option label="餐厅名" value="1"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="性别:">
              <el-select @change="selectChange" v-model="listQuery.Gender" placeholder="请选择" clearable>
                <el-option v-for="item in sex" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否包住:">
              <el-select @change="selectChange" v-model="listQuery.IncludeStay" placeholder="请选择" clearable>
                <el-option v-for="item in stay" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否包吃:">
              <el-select @change="selectChange" v-model="listQuery.PackageEat" placeholder="请选择" clearable>
                <el-option v-for="item in eat" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="综合薪资:">
              <el-input v-model="listQuery.ComprehensiveSalary" type="number" clearable></el-input>
            </el-form-item>
            <!-- <el-form-item label="社保公积金:">
              <el-select v-model="listQuery.SocialSecurityPaymentMethod" clearable @change="socialChange">
                <el-option v-for="(item, index) in socialSecurityList" :key="index" :label="item.StrSocialsecName" :value="item.StrSocialsecName">
                </el-option>
              </el-select>
            </el-form-item> -->
          </el-form>
        </div>
        <div class="drop-footer">
          <el-button size="small" plain @click="resetHandle()">清空</el-button>
          <el-button size="small" type="success" plain @click="seach()">搜索</el-button>
          <el-button size="small" plain @click="showDropScreen=-1">关闭</el-button>
        </div>
      </div>
    </div>

    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>招聘需求</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="recruitTable" v-if="checkPermission(['recruitDemand_page_list'],permissionLists)">
        <div class="ftabs flex sb">
          <el-tabs v-model="active" type="card" @tab-click="handleClick">
            <el-tab-pane :label="'全部（' + allNum + '）'" name="全部"></el-tab-pane>
            <el-tab-pane :label="'招聘中（' + offeringNum + '）'" name="招聘中"></el-tab-pane>
            <!-- 招聘不能看 -->
            <el-tab-pane :label="'待招聘（' + tbhNum + '）'" name="待招聘" v-if="checkPermission(['recruitDemand_tab_recruited'],permissionLists)"></el-tab-pane>
            <el-tab-pane :label="'已停招（' + stopNum + '）'" name="已停招"></el-tab-pane>
          </el-tabs>
          <div style="height: 41px;line-height: 41px;">
            <el-button size="small" type="warning" v-if="hasPermission" plain @click="batchDistribution">批量分配</el-button>
            <el-button size="small" type="success" plain @click="downPostHandle">下载岗位表格</el-button>
            <el-button v-if="!isNull(tableData)&&checkPermission(['recruitDemand_export'],permissionLists)" :loading="btnLoading" size="small" plain type="success" class="com_dialog_btn" @click="exportHandle">导出</el-button>
            <el-button size="small" type="success" @click="createdDmand()" v-if="checkPermission(['recruitDemand_add'],permissionLists)">创建招聘需求+</el-button>
          </div>
        </div>
        <div v-loading="loading" element-loading-text="拼命加载中">
          <el-table ref="multipleTable" @selection-change="handleSelectionChange" :data="tableData" border :max-height="(tableHeight-240) > 450 ? tableHeight-240 : 450" style="width: 99%;" v-if="(tableTitle.length>0)" :header-cell-style="headStyle" :cell-class-name="tableCellClassName">
            <el-table-column align="center" type="selection" width="55"></el-table-column>
            <el-table-column label="操作" width="110px" fixed="left" header-align="center">
              <template slot-scope="scope">
                <div class="tableBtn">
                  <span @click="talk(scope.row)">沟通</span>
                  <span @click="toDetail(scope.row,'look')">查看</span>
                  <span @click="toDetail(scope.row,'edit')" v-if="scope.row.isCanUpdata == 1">编辑</span>
                  <span @click="hangdel(scope.row,'visibleStop')" v-if="scope.row.isCanUpdata == 1">{{ scope.row.StrPlanstatus == '待招聘'|| scope.row.StrPlanstatus == '已停招' ? '开启' : '停招'}}</span>
                  <span @click="hangdel(scope.row,'visibleDistribution')" v-if="scope.row.depLeadOrgCode!=null && scope.row.depLeadOrgCode">{{scope.row.isWaitDistribution==1 ?'待分配' : '分配'}}</span>
                  <span @click="hangdel(scope.row,'visibleCopy')" v-if="scope.row.isCanUpdata == 1">复制</span>
                  <span @click="hangdel(scope.row,'visibledel')" v-if="scope.row.isCanUpdata == 1 && scope.row.StrPlanstatus=='待招聘'&&checkPermission(['recruitDemand_dlt'],permissionLists)">删除</span>
                  <!-- <span >删除1{{ item.CreateUserId }}</span>
                  <span >删除2{{ item.StrPlanstatus }}</span>
                  <span >删除3{{ CurrentUserId }}</span>
                  <span >删除1{{ item.Id }}</span> -->
                </div>
              </template>
            </el-table-column>
            <template v-for="(item,index) in tableTitle">
              <el-table-column :key="index" :prop="item.node.StrColumId" :label="item.node.StrColumName" fit header-align="center" :width="item.node.StrColumName=='优先级' ? '46px' : item.node.StrColumName=='更新时间' ? '83px' : item.node.StrColumName=='项目名称' ? '140px' : ''" :fixed="(item.node.StrColumName=='项目名称'||item.node.StrColumName=='岗位名称')?true:false">
                <template slot-scope="scope">
                  <div v-if="item.node.StrColumName == '项目名称'" style="padding-right: 25px;">
                    <div class="badge" v-if="new Date().getTime()-24*60*60*1000 < new Date(scope.row.UpdateTime).getTime()">
                      <el-badge value="New" class="item">
                        {{ scope.row[item.node.StrColumId] }}
                      </el-badge>
                    </div>
                    <div v-else>{{ scope.row[item.node.StrColumId] }}</div>
                  </div>
                  <div v-else>{{ scope.row[item.node.StrColumId] }}</div>
                </template>
                <el-table-column v-for="(children,index) in item.child" :key="index" :prop="children.StrColumId" :label="children.StrColumName" v-if="children.isShow != false" :min-width="(children.StrColumName=='有社保公积金' ? '84px' : children.StrColumName=='运营负责人' ? '83px' : children.StrColumName.length>10 ? '188px' : '80px')" :show-overflow-tooltip="true" header-align="center">
                  <template slot-scope="scope">
                    <!-- <div v-if="children.StrColumId=='StrgapNum'">
                      <div class="flex" v-if="scope.row.StrgapNum.indexOf('|')>-1">
                        <div>{{scope.row.StrgapNum.split('|')[0]}}</div>
                        <div class="cp" style="margin-left: 5px;color:rgb(51, 153, 255);" @click="downloadFile(scope.row.StrgapNum.split('|')[1])">下载附件</div>
                      </div>
                      <div v-else>{{ scope.row.StrgapNum }}</div>
                    </div> -->
                    <div v-if="!isNull(children.StrColumName) && children.StrColumName.indexOf('-') == 4">
                      <div v-if="!isNull(scope.row[children.StrColumId].str1) && !isNull(scope.row[children.StrColumId].str2)">
                        <div>{{ scope.row[children.StrColumId].str1 }}</div>
                        <div>{{ scope.row[children.StrColumId].str2 }}</div>
                      </div>
                      <div v-else>{{ scope.row[children.StrColumId] }}</div>
                    </div>
                    <div v-else>
                      <a v-if="scope.row[children.StrColumId] == '预览图片'" style="color:#19bd92;text-decoration: underline;" :href="headUrl + scope.row[children.StrColumId]" target="_blank">{{scope.row[children.StrColumId]}}</a>
                      <span v-if="scope.row[children.StrColumId] == '预览附件'" @click="preViewFile(scope.row.StrgapNumUrl)" style="color:#19bd92;text-decoration: underline;cursor: pointer;">{{ scope.row[children.StrColumId] }}</span>
                      <span v-else>{{ scope.row[children.StrColumId] }}</span>
                    </div>
                  </template>
                </el-table-column>
                <template slot="header" v-if="index>3 && index<8">
                  <div class="showMoreHead cp">
                    <span>
                      {{item.node.StrColumName}}
                    </span>
                    <i class="el-icon-d-arrow-left" v-show="item.node.isShow == 'less'" title="点击收起更多" @click="showMoreHead(item,'more',false)"></i>
                    <i class="el-icon-d-arrow-right cp" v-show="item.node.isShow == 'more'" title="点击显示更多" @click="showMoreHead(item,'less',true)"></i>
                  </div>
                </template>
              </el-table-column>
            </template>
          </el-table>
        </div>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="recruitCurrentChange" :current-page.sync="listQuery.pageNum" :page-size="listQuery.pageSize" @size-change="handleSizeChange" :page-sizes="[20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="确定下载" :visible.sync="downVisible" width="450px">
      <div style="font-size: 14px;">请确认，是否下载导出数据？</div>
      <span slot="footer" class="dialog-footer">
        <button class="clear" @click="downVisible = false">取消</button>
        <button class="search" @click="confirmDown" style="margin-left:10px;font-weight:600">确定</button>
      </span>
    </el-dialog>
    <el-dialog title="沟通" :visible.sync="visibleTalk" width="600px">
      <div>
        <span>项目名称：</span>
        <span>{{row.StrprojectName}}</span>
      </div>
      <div class="flex" style="margin-top: 10px;">
        <span class="talktitle">沟通内容：</span>
        <el-input type="textarea" placeholder="请输入内容" :rows="4" v-model="talkQuery.StrCommunicate"></el-input>
      </div>
      <div class="uploadbox">
        <!-- <el-checkbox v-model="talkQuery.IsSyncWechat" :true-label="1" :false-label="0">微信同步发送</el-checkbox> -->
        <el-upload class="upload-demo" action="" :on-change="success_handle" :auto-upload="false" :limit="3" :on-remove="handleRemove" :on-exceed="handleExceed" :file-list="fileList">
          <el-button size="small" style="margin-top: 15px;" type="success">上传附件</el-button>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="clear" @click="visibleTalk = false">取消</button>
        <button class="search" @click="setTalk()" style="margin-left:10px;font-weight:600">确定</button>
      </span>
    </el-dialog>

    <el-dialog :title="'确认' + row.StrPlanstatus == '待招聘' || row.StrPlanstatus == '已停招' ? '开启招聘' : '停止招聘'" :visible.sync="visibleStop" width="450px">
      <div style="font-size: 14px;">请确认，是否{{listQuery.StrPlanstatus == '招聘中' ? '停招' : '开启招聘'}}需求？</div>
      <span slot="footer" class="dialog-footer">
        <button class="clear" @click="visibleStop = false">取消</button>
        <button class="search" @click="confirmStop()" style="margin-left:10px;font-weight:600">确定</button>
      </span>
    </el-dialog>
    <el-dialog :title="'确认删除' " :visible.sync="visibledel" width="450px">
      <div style="font-size: 14px;">请确认，删除需求？</div>
      <span slot="footer" class="dialog-footer">
        <button class="clear" @click="visibledel = false">取消</button>
        <button class="search" @click="confirmdel()" style="margin-left:10px;font-weight:600">确定</button>
      </span>
    </el-dialog>

    <el-dialog title="复制招聘需求" :visible.sync="visibleCopy" width="600px">
      <div class="flex" style="margin-top: 10px;">
        <span class="dialogtitle">复制到：</span>
        <el-select @change="selectChange" style="margin-left: 10px;" v-model="copyProId" filterable clearable placeholder="请选择项目">
          <el-option v-for="item in prolist" clearable :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="clear" @click="visibleCopy = false">取消</button>
        <button class="search" @click="confirmCopy()" v-preventReClick style="margin-left:10px;font-weight:600">确定</button>
      </span>
    </el-dialog>

    <el-dialog title="分配招聘需求" :visible.sync="visibleDistribution" width="800px">
      <div>
        <!-- 分配招聘部门 -->
        <div class="p_plan_form p_plan_form01">
          <div class="plan_form_list">
            <div class="p_plan_item">
              <div class="p_plan_title note_form">分配招聘顾问:</div>
              <div class="p_plan_right">
                <el-cascader size="small" ref="departLabel" :key="modalKey" v-model="perDepartList" :props="deportPropDia" clearable filterable :options="disDepartList" placeholder="请选择招聘顾问" @change="perDiaSectionChange"></el-cascader>
              </div>
            </div>
          </div>
        </div>
        <div class="p_plan_form p_plan_form03">
          <!-- <div class="plan_form_list">
            <div class="p_plan_item">
              <div class="p_plan_title">指定主招招聘顾问:</div>
              <div class="p_plan_right p_plan_right01">
                <el-select class="plan_input02" size="small" v-model="memberQuery" filterable clearable @change="partnerSelChange" placeholder="请选择主招招聘顾问">
                  <el-option v-for="(item, index) in memberList" :key="index" :label="item.Username" :value="{label:item.Username,value:item.Userid}">
                  </el-option>
                </el-select>
                <el-checkbox v-model="depUserQuery.checked">需求屏蔽部门其他人</el-checkbox>
              </div>
            </div>
            <div class="p_plan_item">
              <el-button size="mini" type="primary" @click="addDepHandle">添加</el-button>
            </div>
          </div> -->
          <div class="plan_form_list">
            <div class="p_plan_record" v-for="(item,index) in depDiaUserList" :key="index">
              <span>{{index+1}}.</span>
              <span v-if="item.StradviseruserName">{{item.StradviseruserName}}。</span>
              <span v-if="item.Strorganname">{{item.Strorganname}}。</span>
              <i class="el-icon-close" v-if="!isNullDate(item.StradviseruserId)" @click="dltDAtaHandle(depDiaUserList,index,item)"></i>
              <el-checkbox v-if="item.StradviseruserId" v-model="item.checked" style="margin-left:25px;">主招</el-checkbox>
            </div>
            <!-- 新增的部分 -->
            <div class="p_plan_record" v-for="(item,index) in diaUserList" :key="index+'k'">
              <span>{{Number(depDiaUserList.length)+index+1}}.</span>
              <span v-if="item.StradviseruserName">{{item.StradviseruserName}}。</span>
              <span v-if="item.Strorganname">{{item.Strorganname}}。</span>
              <i class="el-icon-close" @click="dltDAtaHandle(diaUserList,index,item)"></i>
              <el-checkbox v-if="item.StradviseruserId" v-model="item.checked" style="margin-left:25px;">主招</el-checkbox>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="clear" @click="visibleDistribution = false">取消</button>
        <button class="search" @click="confirmDistribution()" style="margin-left:10px;font-weight:600">确定</button>
      </span>
    </el-dialog>

    <el-dialog title="批量分配招聘需求" :visible.sync="visibleDistributionBatch" width="800px">
      <div>
        <!-- 分配招聘部门 -->
        <div class="p_plan_form p_plan_form01">
          <div class="plan_form_list">
            <div class="p_plan_item">
              <div class="p_plan_title note_form">分配招聘顾问:</div>
              <div class="p_plan_right">
                <el-cascader size="small" ref="departLabel" :key="modalKey" v-model="perDepartList" :props="deportPropDia" clearable filterable :options="disDepartList" placeholder="请选择招聘顾问" @change="perDiaSectionChange"></el-cascader>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visibleDistributionBatch = false">取消</el-button>
        <el-button type="primary" size="small" v-preventReClick :loading="isBtnLoading" @click="confirmDistributionBatch()" style="margin-left:10px;font-weight:600">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import FUN from "./../../fun";
  import xz from "./../../common.vue";
  import checkPermission from '@/utils/permission' // 权限判断函数
  // import labelManage from "./components/labelManage.vue";
  export default {
    // components: {
    //   labelManage
    // },
    data() {
      return {
        depDiaAllUserList: [], //分配所有详情部门人员
        tableHeight: 0,
        roletype: localStorage.loginRoletype,
        tablePath: this.$store.state.EMP.tablePath,
        CurrentUserId: Cookies.get("userid-b"),
        //下拉筛选
        showDropScreen: -1,
        userLabel: localStorage.userLabel,
        talkList: [], //沟通列表
        oneInfo: [], //沟通最新一条
        prolist: [], //项目列表
        jobCategoryList: [], //岗位类别列表
        customerList: [], //客服列表
        partnerList: [], //合伙人参数
        stay: [], //是否包住
        sex: [], //岗位性别
        eat: [], //是否包吃
        socialSecurityList: [], // 社保
        depMemberQuery: {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "在职",
          strstation: "",
          strorgancode: ""
        },
        active: "招聘中",
        listQuery: {
          //需求参数
          interviewStartTime: new Date(),
          interviewEndTime: new Date(Date.now() + 6 * (24 * 60 * 60 * 1000)),
          ProjectId: "",
          JobCategory: "", //岗位
          strDep1: "", //部门一级
          strDep2: "", //部门二级
          strDep3: "", //部门三级
          strservuserid: "", //客服
          WorkCityName: "", //城市
          strpartner2: "", //合伙人
          strbusdep: "", //业绩归属部门
          Gender: "", //性别
          IncludeStay: "", //包住
          PackageEat: "", //包吃
          SocialSecurityPaymentMethod: "", //社保
          StrPlanstatus: "招聘中",
          ComprehensiveSalary: "", //综合薪资
          pageNum: 1,
          pageSize: 20,
        },
        ProjectId: "",
        pageQuery: {
          ProjectId: "",
          pageNum: 1,
          pageSize: 10,
        },
        talktotal: 0, //沟通总数
        row: {},
        visibleTalk: false,
        ismore: false,
        departList: [],
        loading: false,
        // 自定义 级联选择props
        props: {
          label: "strorganname",
          value: "strorgancode",
          children: "children",
          checkStrictly: true,
        },
        //部门props
        deportProps: {
          label: "strorganname",
          value: "strorgancode",
          children: "children",
          checkStrictly: true,
        },
        deportPropDia: {
          label: "strorganname",
          value: "strorgancode",
          children: "children",
          multiple: true,
        },
        tableTitle: [],
        tableData: [],
        totalCount: 0, //需求总数
        fileList: [],
        //沟通参数
        talkQuery: {
          ProjectId: "",
          StrCommunicate: "",
          IsSyncWechat: 0,
          GduserName: localStorage.ganName + "/" + localStorage.userName,
          FileList: [],
        },
        visibleStop: false,
        visibledel: false,
        isBtnLoading: false,
        hasPermission: false, //是否有批量分配权限
        visibleDistribution: false, //分配招聘需求
        visibleDistributionBatch: false, //批量分配招聘需求
        visibleCopy: false,
        GdrecpIds: '',
        copyProId: "",
        query: "",
        // 招聘计划
        planQuery: {
          GdrecpId: "", // 计划id
          Projectid: "", // 项目id
          Jobid: "", // 岗位ID 633240d3-8372-42c2-b546-b5f1584a4aac
          StrDateterm: "", // 招聘期限
          StrRemark: "", // 备注（目前无）
          GduserId: Cookies.get("userid-b"),
          GduserName: "", // 登录人姓名
          StrIsredate: "", // 是否重复排期 是 否
          StrPlanstatus: "", // 计划状态
        },
        // 缺口记录
        gapList: [],
        // 招聘排期
        termList: [],
        // 排期参数
        termQuery: {
          dateend: "",
          datestart: "",
          datetype: "", // 是否重复排期
          gdrecpId: "", // 不传默认为新增
        },
        // 招聘部门列表
        depUserList: [],
        perDepartList: "",
        // 招聘部门和顾问参数
        depUserQuery: {
          Strorgancode: "", // 部门id
          StradviseruserId: "", // 招聘顾问id
          StradviseruserName: "", // 招聘顾问姓名
          StrIsshield: "否", // 是否需要屏蔽 是或者否
          checked: false,
          StrRemark: "", // 备注（目前无）
        },
        memberList: [],
        memberQuery: {
          StradviseruserId: "", // 招聘顾问id
          StradviseruserName: "", // 招聘顾问姓名
        },
        hasNum: false, //false时 取数量，true时不取
        allNum: 0, //全部数量
        stopNum: 0, //停招数量
        offeringNum: 0, //招聘中数量
        tbhNum: 0, //待招聘数量
        // 分配部门列表
        disDepartList: [],
        selected: '',
        disDepartQuery: {
          strorgancode: "",
        },
        depDiaUserList: [],
        // 新增的分配部门和人员
        diaUserList: [],
        // 分配招聘顾问选中的值
        depSelectedList: [],
        // 表格多选的值
        multipleSelection: [],
        idList: [],
        exportQuery: {
          pagecount: 1000000,
          currpage: 1,
          ststus: "岗位信息导出",
          Ids: "",
        },
        btnLoading: false,
        downVisible: false,
        propsAddress: {
          label: 'Name',
          value: 'Name',
          children: 'children',
        },
        custPath: "",
        isFileOrImg: false,
        allUserList: [],
        areaList: [],
        modalKey: 0,
        headUrl: location.origin.indexOf("localhost") > -1 ?
          "https://dev.joball.net/clouddoc/" : location.origin + "/clouddoc/",
        // 按钮权限参数
        butQuery: {
          path: '/recruitDemand',
          powerEnName: 'employee'
        },
        permissionLists: []
      };
    },
    created() {
      this.getprovinces();
      this.calHeight();
      this.getButtonPower(); //获取按钮权限
      this.getTreestr();
      this.getProList();
      this.getcomrecord(false);
      this.getNum();
      this.getDepartList(); //获取部门列表
    },
    mounted() {},
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        xz.getbtnPowerIdBypage(this.butQuery).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
              if (that.checkPermission(['recruitDemand_page_list'], that.permissionLists)) {
                that.searchRecruitmentneed()
              }
            } else {
              this.permissionLists = []
            }
          } else {
            this.permissionLists = []
          }
        })
      },
      handleSelectionChange(val) {
        // console.log('kk',val)
        this.multipleSelection = val;
      },
      // 下载岗位表格
      downPostHandle() {
        xz.getImportModeUrl('output_JB_busi_RecrJob', '招聘需求表').then(res => {
          // console.log('下载模板', res)
          if (res) {
            var d = res.msg.data.StrOutPath
            d = d.replace("\"", "").replace("\"", "")
            var path = this.tablePath + d
            const aTag = document.createElement('a')
            aTag.href = path
            aTag.click();
          }
        })
      },
      // 确定下载导出数据
      confirmDown() {
        let path = this.tablePath + this.custPath;
        const aTag = document.createElement("a");
        aTag.href = path;
        aTag.click();
        this.downVisible = false;
      },
      // 简历导出
      exportHandle() {
        this.exportQuery.Ids = ''
        this.idList = []
        if (this.isNull(this.multipleSelection)) {
          this.$message({
            message: "请选择要导出的数据",
            type: "warning",
          });
          return false;
        } else {
          for (let i = 0; i < this.multipleSelection.length; i++) {
            let element = this.multipleSelection[i];
            this.idList.push(element.Id);
          }
          this.exportQuery.Ids = this.idList.toString();
          this.btnLoading = true;
          // console.log('ll',this.exportQuery)
          xz.outputJobList("5", this.exportQuery).then((res) => {
            if (res.status == "ok") {
              // console.log('ll',res)
              this.custPath = res.stroutpath;
              this.downVisible = true;
            }
            this.btnLoading = false;
          });
        }
      },
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
      },
      getProList() {
       let str = `Project/GetEmployeeProjectList?UserId=${Cookies.get("userid-b")}`
        xz.rcGetFun(str).then((res) => {
          if (res.status == "ok") {
            this.prolist = res.data;
          } else {
            this.prolist = [];
          }
        });
      },
      // 获取分配部门列表
      getDepartList01(strorgancode) {
        xz.getOrganstrsreach(strorgancode, {
          strIsDisable: "1",
        }).then((res) => {
          // console.log('部门', res)
          if (res.status == "ok") {
            if (res.msg && res.msg.parent) {
              this.disDepartList = res.msg.parent;
            } else {
              this.disDepartList = [];
            }
            // console.log('部门', this.departList)
          }
        });
      },
      //获取岗位
      getTreestr() {
        let data = {
          currpage: 1,
          perpage: 1000,
          strIsDisable: "",
          keyword: "",
        };
        xz.getTreestr("JB_base_Jobcategory", data).then((res) => {
          if (res) {
            this.jobCategoryList = res.msg.parent;
          } else {
            this.jobCategoryList = [];
          }
        });
      },
      downloadFile(url) {
        if (url) {
          url = this.$store.state.EMP.docPath + url;
          const aTag = document.createElement("a");
          aTag.href = url;
          aTag.click();
        }
      },
      //获取沟通列表
      getcomrecord(isAll) {
        !this.ProjectId ?
          (this.pageQuery.ProjectId = 0) :
          (this.pageQuery.ProjectId = this.ProjectId);
        xz.getcomrecord(this.pageQuery, localStorage.loginRoletype).then(
          (res) => {
            // console.log('getcomrecord', res)
            if (res.status == "ok" && res.data.count > 0) {
              this.talktotal = res.data.count;
              this.talkList = res.data.retList;
              this.oneInfo = res.data.retList;
              this.$nextTick(() => {
                let uls = this.$refs.talkinfo.getElementsByClassName("talkinfo");
                // console.log('getcomrecord',uls)
                this.talkList.forEach((item, index) => {
                  if (uls[index].clientHeight > 41) {
                    this.$set(item, "isHas", true);
                  } else {
                    this.$set(item, "isHas", false);
                  }
                  this.$set(item, "isMoreShow", false);
                });
              });
            } else {
              this.talktotal = 0;
              this.talkList = 0;
              this.oneInfo = [];
              this.talkList = [];
            }
          }
        );
      },
      // //沟通更多
      // more() {
      //   this.ismore = true;
      //   this.oneInfo = this.talkList;
      // },
      // stow() {
      //   this.ismore = false;
      //   this.oneInfo = [];
      //   this.oneInfo.push(this.talkList[0]);
      // },
      showMoreHead(item, ismore, isshow) {
        console.log(item);
        // this.loading = true;
        // setTimeout(() => {
        //   this.loading = false;
        // }, 500)
        this.$set(item.node, "isShow", ismore);
        item.child.forEach((element, index) => {
          if (index > 0) {
            this.$set(element, "isShow", isshow);
          }
        });
      },
      selectChange() {},
      selectPro() {
        this.getcomrecord(this.ismore);
      },
      //沟通切换页码
      handleCurrentChange(val) {
        this.pageQuery.pageNum = Number(val);
        this.getcomrecord(true);
      },
      //沟通
      talk(row) {
        this.row = row;
        this.visibleTalk = true;
        this.talkQuery.ProjectId = row.Projectid;
        console.log(this.talkQuery.ProjectId, row);
      },
      //上传附件
      success_handle(file, fileList) {
        console.log(file, fileList);
        const formData = new FormData();
        formData.append("pagename", "docinf");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            let item = {
              Url: res,
              FileName: file.name,
            };
            this.talkQuery.FileList.push(item);
          } else {
            this.fileList = [];
          }
        });
      },
      handleRemove(file) {
        this.talkQuery.FileList.forEach((ele, index) => {
          if ((ele) => file.FileName === file.name) {
            this.talkQuery.FileList.splice(index, 1);
          }
        });
        console.log(file, this.talkQuery.FileList);
      },
      handleExceed() {
        this.$message.warning(`当前限制最多上传 3 个文件`);
      },
      //新建沟通
      setTalk() {
        if (!this.talkQuery.StrCommunicate) {
          this.$message.warning("请输入沟通内容");
        } else {
          xz.addcomrecord(this.talkQuery).then((res) => {
            console.log(res);
            if (res.status == "ok") {
              this.$message.success("保存成功");
              this.talkQuery = {
                ProjectId: "",
                StrCommunicate: "",
                IsSyncWechat: 0,
                GduserName: localStorage.ganName + "/" + localStorage.userName,
                FileList: [],
              };
              this.getcomrecord(false);
              this.visibleTalk = false;
            }
          });
        }
      },
      //选择岗位
      changeJob(val) {
        if (val.length > 0 && val != undefined) {
          this.listQuery.JobCategory = val[val.length - 1];
          this.$refs.cascader._data.dropDownVisible = false;
        } else {
          this.listQuery.JobCategory = "";
        }
        console.log(val, this.listQuery.JobCategory);
        this.seach();
      },
      handleClick(tab) {
        if (tab.$options.propsData.name == "全部") {
          this.listQuery.StrPlanstatus = "";
        } else {
          this.listQuery.StrPlanstatus = tab.$options.propsData.name;
        }
        this.seach();
      },
      getNum() {
        let listQuery = {
          interviewStartTime: this.listQuery.interviewStartTime,
          interviewEndTime: this.listQuery.interviewEndTime,
          ProjectId: this.listQuery.ProjectId,
          JobCategory: this.listQuery.JobCategory, //岗位
          strDep1: this.listQuery.strDep1, //部门一级
          strDep2: this.listQuery.strDep2, //部门二级
          strDep3: this.listQuery.strDep3, //部门三级
          strservuserid: this.listQuery.strservuserid, //客服
          WorkCityName: this.listQuery.WorkCityName, //城市
          strpartner2: this.listQuery.strpartner2, //合伙人
          strbusdep: this.listQuery.strbusdep, //业绩归属部门
          Gender: this.listQuery.Gender, //性别
          IncludeStay: this.listQuery.IncludeStay, //包住
          PackageEat: this.listQuery.PackageEat, //包吃
          SocialSecurityPaymentMethod: this.listQuery.SocialSecurityPaymentMethod, //社保
          StrPlanstatus: "",
          ComprehensiveSalary: this.listQuery.ComprehensiveSalary, //综合薪资
          pageNum: 1,
          pageSize: 20,
        };
        xz.searchRecruitmentneed(listQuery, localStorage.loginRoletype).then(
          (res) => {
            if (
              res.data.totalCountList != undefined &&
              res.data.totalCountList.length > 0
            ) {
              res.data.totalCountList.forEach((ele) => {
                if (ele.StrPlanstatus == "全部") {
                  this.allNum = ele.EntNum;
                } else if (ele.StrPlanstatus == "已停招") {
                  this.stopNum = ele.EntNum;
                } else if (ele.StrPlanstatus == "招聘中") {
                  this.offeringNum = ele.EntNum;
                } else if (ele.StrPlanstatus == "待招聘") {
                  this.tbhNum = ele.EntNum;
                }
                this.hasNum = true;
              });
            }
          }
        );
      },
      selectProRecruit() {
        this.active = "全部";
        this.listQuery.StrPlanstatus = "";
        this.searchRecruitmentneed();
      },
      // 预览缺口附件
      preViewFile(url) {
        let file = this.headUrl + url;
        let lastIndex = file.lastIndexOf(".");
        let suffix = file.substring(lastIndex + 1);
        //文件格式是word文档、ppt、excel文件文件时
        if (
          suffix == "doc" ||
          suffix == "docx" ||
          suffix == "ppt" ||
          suffix == "xls" ||
          suffix == "xlsx"
        ) {
          let fileUrl = encodeURIComponent(file);
          //使用Office Web查看器
          let officeUrl =
            "http://view.officeapps.live.com/op/view.aspx?src=" + fileUrl;
          window.open(officeUrl, "_target");
        } else {
          //其他文件格式比如pdf、图片、html
          window.open(file);
        }
      },
      //获取需求列表
      searchRecruitmentneed() {
        this.loading = true;
        this.tableTitle = [];
        this.tableData = [];
        xz.searchRecruitmentneed(this.listQuery, localStorage.loginRoletype).then(
          (res) => {
            if (res.status == "ok") {
              // console.log(res)
              res.data.retTableHeadInfoList.forEach((element, index) => {
                // if (index > 1) {
                if (index > 3 && index < 8) {
                  this.$set(element.node, "isShow", "more");
                }
                // console.log('7',element)
                element.child.forEach((chlid, index2) => {
                  if (index == 4) {
                    if (index2 >= 0) {
                      res.data.RetTbList.forEach((e) => {
                        e.UpdateTime = e.UpdateTime.replace("T", " ");
                        // 缺口附件
                        let b = e.StrgapNum;
                        // console.log('b',b)
                        if (!this.isNull(b)) {
                          let fileArrIndex = b.indexOf("|");
                          if (fileArrIndex > -1) {
                            let str3 = b.substring(0, fileArrIndex);
                            let str4 = b.substring(fileArrIndex + 1, b.length);
                            if (
                              str4.indexOf(".png") > -1 ||
                              str4.indexOf(".jpg") > -1 ||
                              str4.indexOf(".gif") > -1
                            ) {
                              this.$set(e, "StrgapNum", "预览图片");
                            } else {
                              this.$set(e, "StrgapNum", "预览附件");
                            }
                            this.$set(e, "StrgapNumUrl", str4);
                            // let obj1 = {
                            //   strNum: str3,
                            //   strUrl: str4
                            // }
                            // this.$set(e, 'StrgapNumObj', obj1)
                          }
                        }
                        let a = e[chlid.StrColumId];
                        // console.log('9',a)
                        if (!this.isNull(a)) {
                          let index = a.indexOf(",");
                          if (index > -1) {
                            let str1 = a.substring(0, index);
                            let str2 = a.substring(index + 1, a.length);
                            let obj = {
                              str1: str1,
                              str2: str2,
                            };
                            this.$set(e, [chlid.StrColumId], obj);
                            // console.log('3', e)
                          }
                        }
                      });
                    }
                  }
                  if (index > 1) {
                    if (index2 > 0) {
                      this.$set(chlid, "isShow", false);
                    }
                    if (
                      index == res.data.retTableHeadInfoList.length - 1 &&
                      index2 == element.child.length - 1
                    ) {
                      this.tableTitle = res.data.retTableHeadInfoList;
                    }
                  }
                });
                // }
              });

              this.tableData = res.data.RetTbList;
              this.hasPermission = res.data.RetTbList.some(item => item.depLeadOrgCode != null && item.depLeadOrgCode !== '');
              // console.log('kk',this.tableData)
              this.totalCount = res.data.totalCount;
            } else {
              this.tableTitle = [];
              this.tableData = [];
              this.totalCount = 0;
            }
            this.showDropScreen = -1;
            this.loading = false;
          }
        );
      },
      recruitCurrentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.searchRecruitmentneed();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.searchRecruitmentneed();
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          if (this.sex.length == 0) {
            this.getCusList();
            this.getMemberList();
            this.getdictdatalistbyid(48, "sex");
            this.getdictdatalistbyid(57, "eat");
            this.getdictdatalistbyid(44, "stay");
            this.getParamList();
          }
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      //获取省市区
      getprovinces() {
        xz.getAreaAll().then(res => {
          // console.log('getprovinces', res)
          // if (res.status == 'ok') {
          this.areaList = res;
          if (!this.isNull(this.areaList)) {
            for (const key in this.areaList) {
              // 删除第三层children属性
              for (const i in this.areaList[key].children) {
                delete this.areaList[key].children[i].children
              }
            }
          }
          // } else {
          //   this.areaList = [];
          // }
        })
      },
      // 获取部门列表
      getDepartList() {
        xz.getorganstr("", "", {
          strIsDisable: "",
        }).then((res) => {
          if (res.status == "ok") {
            if (res.msg && res.msg.parent) {
              this.departList = res.msg.parent[0].children;
            }
          } else {
            this.departList = [];
          }
        });
      },
      // 获取客服列表
      getCusList() {
        let data = {
          searchVal: "",
          pageNum: 1,
          pageSize: 10000,
        };
        xz.getprojectstrservuseridList(data, localStorage.loginRoletype).then(
          (res) => {
            if (res.status == "ok") {
              this.customerList = res.data;
            } else {
              this.customerList = [];
            }
          }
        );
      },
      // 合伙人列表
      getMemberList() {
        xz.getauthUserInfoByorgancode(this.depMemberQuery).then((res) => {
          if (res.status == "ok") {
            this.partnerList = res.msg;
          } else {
            this.partnerList = [];
          }
        });
      },
      //获取下拉选项
      getdictdatalistbyid(Id, list) {
        xz.getdictdatalistbyid(Id).then((res) => {
          if (res.status == "ok") {
            this[list] = res.data.retList;
          } else {
            this[list] = [];
          }
        });
      },
      //获取社保列表
      getParamList() {
        let data = {
          currpage: 1,
          perpage: 100000,
          keyword: "",
          strIsDisable: "", // 传1 禁用的看不到了  不传就全显示
          strtableid: "JB_base_Socialsec",
        };
        xz.getParameterList(data).then((res) => {
          if (res) {
            this.socialSecurityList = res.msg;
          } else {
            this.socialSecurityList = [];
          }
        });
      },
      // 服务部门选择
      handleSectionChange(value) {
        if (value.length >= 3) {
          this.listQuery.strDep1 = value[0];
          this.listQuery.strDep2 = value[1];
          this.listQuery.strDep3 = value[2];
        }
        if (value.length == 2) {
          this.listQuery.strDep1 = value[0];
          this.listQuery.strDep2 = value[1];
          this.listQuery.strDep3 = "";
        }
        if (value.length == 1) {
          this.listQuery.strDep1 = value[0];
          this.listQuery.strDep2 = "";
          this.listQuery.strDep3 = "";
        }
        if (this.isNullDate(value)) {
          this.listQuery.strDep1 = "";
          this.listQuery.strDep2 = "";
          this.listQuery.strDep3 = "";
        }
        this.$refs.deportCascader._data.dropDownVisible = false;
      },
      // 业绩归属部门选择
      perSectionChange(val) {
        if (this.isNullDate(val)) {
          this.listQuery.strbusdep = "";
        } else {
          this.listQuery.strbusdep = val[Number(val.length) - 1];
        }
        this.$refs.deportCascader2._data.dropDownVisible = false;
      },
      // 修改社保
      socialChange(val) {
        //
      },
      isNullDate(o) {
        // console.log('isnull',o)
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0 ||
          o == "NaN" ||
          o == "1900/01/01" ||
          o == "1900-01-01T00:00:00" ||
          o == "1900-01-01"
        );
      },
      //判断是否为空(包含0)
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0 ||
          o == "NaN" ||
          o == "1900-01-01" ||
          o == "1900-01-01T00:00:00"
        );
      },
      //清空
      resetHandle() {
        this.listQuery = {
          interviewStartTime: new Date(),
          interviewEndTime: new Date(Date.now() + 6 * (24 * 60 * 60 * 1000)),
          ProjectId: "",
          JobCategory: "", //岗位
          strDep1: "", //部门一级
          strDep2: "", //部门二级
          strDep3: "", //部门三级
          strservuserid: "", //客服
          WorkCityName: "", //城市
          strpartner2: "", //合伙人
          strbusdep: "", //业绩归属部门
          Gender: "", //性别
          IncludeStay: "", //包住
          PackageEat: "", //包吃
          SocialSecurityPaymentMethod: "", //社保
          StrPlanstatus: "",
          pageNum: 1,
          pageSize: 10,
        };
      },
      //创建/编辑 需求
      createdDmand() {
        let routeUrl = this.$router.resolve({
          path: "/demandUpdate",
        });
        window.open(routeUrl.href, "_blank");
      },
      //操作弹窗
      hangdel(row, type) {
        this.row = row;
        this[type] = true;
        this.planQuery.GdrecpId = row.GdrecpId;
        this.termQuery.gdrecpId = row.GdrecpId;
        this.disDepartQuery.strorgancode = row.depLeadOrgCode;
        if (type == "visibleCopy") {
          xz.getjobdetails(this.row.Id).then((res) => {
            let r = JSON.parse(res);
            if (r.status == "ok") {
              this.query = r.data;
              this.query.Id = "";
              this.query.CustomerJobName = r.data.CustomerJobName + "1";
            }
          });
          if (row.GdrecpId) {
            // 获取计划详情
            this.getRecruitDtl(this.planQuery.GdrecpId);
            // 获取招聘排期
            this.getTermData();
          }
        } else if (type == "visibleDistribution") {
          this.perDepartList = "";
          this.diaUserList = [];
          this.getDepartList01(this.disDepartQuery.strorgancode);
          // this.getRecruitDtl(this.planQuery.GdrecpId)
          this.getDepDtl(
            this.planQuery.GdrecpId,
            this.disDepartQuery.strorgancode
          );
          // this.$router.push({
          //   path: '/demandUpdate',
          //   query: {
          //     id: row.Id,
          //     GdrecpId: row.GdrecpId,
          //     proId: row.Projectid,
          //     isEdit: 'edit',
          //     activeName: 'second'
          //   }
          // })
        } else if (type == "delJob") {
          console.log("delJob");
        }
      },
      batchDistribution() {
        if (this.multipleSelection.length > 0) {
          this.perDepartList = "";
          this.diaUserList = [];
          this.getDepartList01(this.disDepartQuery.strorgancode);
          this.visibleDistributionBatch = true;
          let arr = [];
          this.multipleSelection.forEach(element => {
            arr.push(element.Id);
          });
          this.GdrecpIds = arr.toString();
        } else {
          this.$message.error("请选择要分配的数据");
        }
      },
      confirmDistributionBatch() {
        this.isBtnLoading = true;
        xz.saveRecruitdepuserbatch({
          GdrecpIds: this.GdrecpIds
        }, this.diaUserList).then(res => {
          if (res.status == 'ok') {
            this.visibleDistributionBatch = false;
            this.$message.success('操作成功');
            this.searchRecruitmentneed();
          } else {
            this.$message.error(res.msg);
          }
          this.isBtnLoading = false;
        });
      },
      // 获取招聘排期
      getTermData() {
        this.termList = [];
        xz.getRecruitPlanTerm(this.termQuery).then((res) => {
          if (!this.isNullDate(res)) {
            let resData = JSON.parse(res);
            this.termUpdateTime = resData.savedate ?
              resData.savedate.replace("T", " ") :
              "";
            // 时间段列表
            this.dateTableList = resData.msgsolt;
            let nodeList = [];
            let tableData01 = [];
            if (!this.isNullDate(resData.msgsolt)) {
              for (let i = 0; i < resData.msgsolt.length; i++) {
                const element01 = resData.msgsolt[i];
                let elementNode01 = element01.Name.split("-");
                nodeList = nodeList.concat(elementNode01);
              }
              // 时间点列表
              this.timeNodeList = [...new Set(nodeList)];
              // 修改返回的数据格式方便排期表格展示
              for (let h = 0; h < resData.msgsolt.length; h++) {
                const element02 = resData.msgsolt[h];
                tableData01.push({
                  StrIsCheck0: "",
                  Strtimeslot: "",
                });
                for (let j = 0; j < resData.msgheard.length; j++) {
                  const element03 = resData.msgheard[j];
                  // 给表头设置StrCloumid，方便与值匹配
                  this.$set(element03, "StrCloumid", "StrIsCheck" + [j]);
                  for (let k = 0; k < resData.msg.length; k++) {
                    const element04 = resData.msg[k];
                    // console.log('ppp', element04)
                    if (
                      element02.Name == element04.Strtimeslot &&
                      element03.StrtimeDate == element04.StrtimeDate
                    ) {
                      this.$set(tableData01[h], "Strtimeslot", element02.Name);
                      this.$set(
                        tableData01[h],
                        "StrIsCheck" + [j],
                        element04.StrIsCheck
                      );
                    }
                  }
                }
              }
              if (!this.isNullDate(resData.msg)) {
                for (let k = 0; k < resData.msg.length; k++) {
                  const element05 = resData.msg[k];
                  // console.log('ppp', element04)
                  if (element05.StrIsCheck == "1") {
                    this.termList.push({
                      Strtimeslot: element05.Strtimeslot, // 时间段
                      StrtimeDate: element05.StrtimeDate, // 日期
                      StrIsCheck: element05.StrIsCheck, // 是否选中（1或者0）
                    });
                  }
                }
              }
            }
          }
        });
      },
      // 查看招聘计划详情
      getRecruitDtl(GdrecpId) {
        xz.getRecruitPlanDetail(GdrecpId).then((res) => {
          if (!this.isNullDate(res)) {
            let results = JSON.parse(res);
            this.gapList = [];
            this.depUserList = [];
            if (results.status == "ok") {
              if (!this.isNullDate(results.msg)) {
                let msgdata = JSON.parse(results.msg);
                this.planQuery = {
                  GdrecpId: msgdata.GdrecpId, // 计划id
                  Projectid: msgdata.Projectid, // 项目id
                  Jobid: msgdata.Jobid, // 岗位ID
                  StrDateterm: msgdata.StrDateterm, // 招聘期限
                  StrRemark: msgdata.StrRemark, // 备注（目前无）
                  GduserId: msgdata.GduserId,
                  GduserName: msgdata.GduserName, // 登录人姓名
                  StrIsredate: msgdata.StrIsredate, // 是否重复排期 是 否
                  StrPlanstatus: msgdata.StrPlanstatus, // 计划状态
                };
              }
              // 缺口记录
              if (!this.isNullDate(results.msggapre)) {
                let msggapre = JSON.parse(results.msggapre);
                for (let i = 0; i < msggapre.length; i++) {
                  const elementGap = msggapre[i];
                  this.gapList.push({
                    StrgapNum: elementGap.StrgapNum, // 缺口数量
                    StrgapCont: elementGap.StrgapCont, // 缺口内容
                    StrEnclosure: elementGap.StrEnclosure,
                    StrEnclosureName: "",
                    updateTime: elementGap.DtInserDate,
                  });
                }
              }
              // 部门/顾问列表
              if (!this.isNullDate(results.msgdepuser)) {
                let msgdepuser = JSON.parse(results.msgdepuser);
                for (let i = 0; i < msgdepuser.length; i++) {
                  const elementUser = msgdepuser[i];
                  this.depUserList.push({
                    Strorganname: elementUser.Strorganname, // 部门名称
                    Strorgancode: elementUser.Strorgancode, // 部门id
                    StradviseruserId: elementUser.StradviseruserId, // 招聘顾问id
                    StradviseruserName: elementUser.StradviseruserName, // 招聘顾问姓名
                    StrIsshield: elementUser.StrIsshield, // 是否主招 是或者否
                    checked: elementUser.StrIsshield == "是" ? true : false,
                    StrRemark: "", // 备注（目前无）
                  });
                }
                // this.depDiaUserList = this.depUserList
              }
            }
          }
        });
      },
      // 获取分配部门人员
      getDepDtl(gdrecpId, strorgancodes) {
        this.depDiaUserList = [];
        xz.getRecruitPlandeps(gdrecpId, strorgancodes).then((res) => {
          if (res.status == "ok") {
            // console.log('ff',res)
            if (!this.isNullDate(res.msg)) {
              let msgdepuser = res.msg;
              for (let i = 0; i < msgdepuser.length; i++) {
                let elementUser1 = msgdepuser[i];
                this.depDiaUserList.push({
                  Strorganname: elementUser1.Strorganname, // 部门名称
                  Strorgancode: elementUser1.Strorgancode, // 部门id
                  StradviseruserId: elementUser1.StradviseruserId, // 招聘顾问id
                  StradviseruserName: elementUser1.StradviseruserName, // 招聘顾问姓名
                  StrIsshield: elementUser1.StrIsshield, // 是否主招 是或者否
                  checked: elementUser1.StrIsshield == "是" ? true : false,
                  StrRemark: elementUser1.StrRemark, // 备注（目前无）
                });
              }
            }
            // if (!this.isNullDate(res.msgdepall)) {
            //   let msgdepuser1 = res.msgdepall
            //   for (let j = 0; j < msgdepuser1.length; j++) {
            //     let elementUser2 = msgdepuser1[j];
            //     this.depDiaAllUserList.push(
            //       { Strorganname: elementUser2.Strorganname, // 部门名称
            //         Strorgancode: elementUser2.Strorgancode, // 部门id
            //         StradviseruserId: elementUser2.StradviseruserId, // 招聘顾问id
            //         StradviseruserName: elementUser2.StradviseruserName, // 招聘顾问姓名
            //         StrIsshield: elementUser2.StrIsshield, // 是否主招 是或者否
            //         checked: elementUser2.StrIsshield == '是' ? true : false,
            //         StrRemark: elementUser2.StrRemark // 备注（目前无）
            //       }
            //     )
            //   }
            // }
          } else {
            this.depDiaUserList = [];
            this.depDiaAllUserList = [];
          }
        });
      },
      //选择地址
      changeAreaHandle(val) {
        if (!this.isNull(val)) {
          this.listQuery.WorkCityName = val[1];
        } else {
          this.listQuery.WorkCityName = ''
        }
      },
      //确认复制
      confirmCopy() {
        // if (this.row.Projectid != this.copyProId) {
        this.query.ProjectId = this.copyProId;
        xz.jobeditorsave(this.query, localStorage.loginRoletype).then((res) => {
          if (res.status == "ok") {
            // 保存计划
            if (res.data.GdrecpId) {
              // this.planQuery.Projectid = this.copyProId;
              // this.submitSave(res.data.Id,res.data.GdrecpId);
              this.getNum();
              this.searchRecruitmentneed();
              this.$message.success("复制成功！");
              this.visibleCopy = false;
            }
          } else {
            this.$message.error(res.msg);
            this.visibleCopy = false;
          }
        });
        // } else {
        //   this.$message.warning('不能复制到同一个项目')
        // }
      },
      // 保存招聘计划
      submitSave(jobid, GdrecpId) {
        this.planQuery.GdrecpId = GdrecpId;
        this.planQuery.Jobid = jobid;
        this.planQuery.StrPlanstatus = "待招聘";
        xz.saveJbBusiRecruitPlan(
          this.planQuery,
          this.gapList,
          this.termList,
          this.depUserList
        ).then((res) => {
          if (!this.isNullDate(res)) {
            let resData = JSON.parse(res);
            if (resData.status == "ok") {
              // 获取列表
              this.getNum();
              this.searchRecruitmentneed();
              this.$message.success("复制成功！");
              this.visibleCopy = false;
            } else {
              this.$message({
                message: "复制失败，请稍后再试",
                type: "error",
              });
            }
          } else {
            this.$message({
              message: "复制失败，请稍后再试",
              type: "error",
            });
          }
        });
      },
      //确认停招
      confirmStop() {
        let data = {
          GdrecpId: this.row.GdrecpId,
          strPlanstatus: this.row.StrPlanstatus == "待招聘" ||
            this.row.StrPlanstatus == "已停招" ?
            "招聘中" : "已停招",
        };
        xz.updatarecruitplanstatus(data, localStorage.loginRoletype).then(
          (res) => {
            if (res) {
              this.visibleStop = false;
              this.getNum();
              this.searchRecruitmentneed();
              this.$message({
                message: res.msg,
                type: res.status == "ok" ? "success" : "error",
              });
            }
          }
        );
      },
      //确认删除
      confirmdel() {
        this.visibledel = false;
        xz.deljobdetails(this.row.Id, localStorage.loginRoletype).then((res) => {
          this.$message({
            message: res.msg,
            type: res.status == "ok" ? "success" : "error",
          });
        });
        this.getNum();
        this.searchRecruitmentneed();
      },
      toDetail(row, type) {
        //查看详情
        if (type == "look") {
          const routerUrl = this.$router.resolve({
            path: "/demandDetail",
            query: {
              id: row.Id,
              GdrecpId: row.GdrecpId,
              proId: row.Projectid,
              isEdit: type,
            },
          });
          window.open(routerUrl.href, "_blank");
        } else {
          //编辑
          const routerUrl = this.$router.resolve({
            path: "/demandUpdate",
            query: {
              id: row.Id,
              GdrecpId: row.GdrecpId,
              proId: row.Projectid,
              isEdit: type,
            },
          });
          window.open(routerUrl.href, "_blank");
        }
      },
      //数组去重
      unique(arr) {
        for (let i = 0; i < arr.length; i++) {
          for (let j = i + 1; j < arr.length; j++) {
            if (!this.isNullDate(arr[i].StradviseruserId)) {
              if (arr[i].StradviseruserId == arr[j].StradviseruserId) {
                //第一个等同于第二个，splice方法删除第二个
                arr.splice(j, 1);
                j--;
              }
            }
          }
        }
        return arr;
        // const resList = new Map();
        // return arr.filter((arr) => !resList.has(arr.StradviseruserId) && resList.set(arr.StradviseruserId, 1));
      },
      //去重
      unique01(arr) {
        const resList = new Map();
        return arr.filter(
          (arr) =>
          !resList.has(arr.StradviseruserId) &&
          resList.set(arr.StradviseruserId, 1)
        );
      },
      // 选择招聘部门
      perDiaSectionChange(val) {
        // console.log('perSectionChange', val, this.disDepartList)
        this.depSelectedList = [];
        this.diaUserList = [];
        let checkedNode = this.$refs["departLabel"].getCheckedNodes();
        if (this.isNullDate(val)) {
          this.perDepartList = [];
        } else {
          for (let i = 0; i < val.length; i++) {
            const valchecked = val[i];
            this.depSelectedList.push(valchecked[valchecked.length - 1]);
          }
          // console.log('checkedNode', checkedNode)
          for (let i = 0; i < checkedNode.length; i++) {
            const elementnode = checkedNode[i];
            let labels = elementnode.pathLabels;
            if (elementnode.value.length > 20) {
              this.diaUserList.push({
                Strorganname: "", // 部门名称
                Strorgancode: elementnode.path[elementnode.path.length - 2], // 部门id
                StradviseruserId: elementnode.value, // 招聘顾问id
                StradviseruserName: labels[labels.length - 1], // 招聘顾问姓名
                StrIsshield: "", // 是否需要屏蔽 是或者否
                checked: "",
                StrRemark: "", // 备注（目前无）
              });
            } else {
              this.diaUserList.push({
                Strorganname: labels[labels.length - 1], // 部门名称
                Strorgancode: elementnode.value, // 部门id
                StradviseruserId: "", // 招聘顾问id
                StradviseruserName: "", // 招聘顾问姓名
                StrIsshield: "", // 是否需要屏蔽 是或者否
                checked: "",
                StrRemark: "", // 备注（目前无）
              });
            }
          }
          // console.log( 'ss',this.diaUserList,'kk',this.depSelectedList )
          let that = this;
          // 去除全选时的部门(过滤包含选中值的数据)
          let differentArr = this.diaUserList.filter((item) => {
            if (!this.isNullDate(item.StradviseruserId)) {
              return this.depSelectedList.indexOf(item.StradviseruserId) != -1;
            } else {
              return this.depSelectedList.indexOf(item.Strorgancode) != -1;
            }
          });
          this.diaUserList = differentArr;
          // 比较返回的旧分配数据和选中的分配数据,去除重复的数据
          let newArr = [];
          this.diaUserList.map((item1) => {
            this.depDiaUserList.map((item2) => {
              if (!that.isNullDate(item1.StradviseruserId)) {
                if (item1.StradviseruserId == item2.StradviseruserId) {
                  //添加属性用来标记相同的对象
                  item1.isRepeat = true;
                }
              } else {
                if (item1.Strorgancode == item2.Strorgancode) {
                  //添加属性用来标记相同的对象
                  item1.isRepeat = true;
                }
              }
            });
          });
          this.diaUserList.map((item) => {
            //通过标记筛选对象
            if (!item.isRepeat) {
              newArr.push(item);
            }
          });
          this.diaUserList = newArr;
          // console.log('88', newArr)
          // 父节点选中，那么所有子孙节点必然是选中的，则反推出：如果节点有父节点且父节点被选中了 过滤掉(全选和不选)
          checkedNode = checkedNode.filter(
            (item) => !(item.parent && item.parent.checked)
          ); // 核心
          this["departLabel"] = checkedNode;
          // console.log( 'userList',this.diaUserList )
          // console.log( 'checkedNode',checkedNode[0],checkedNode[0].data.strType ) ;  //获取当前点击节点的label值
        }
      },
      // 封装方法:根据提供的属性去重
      arrDistinctByProp(arr, prop) {
        let obj = {};
        return arr.reduce(function (preValue, item) {
          obj[item[prop]] ? "" : (obj[item[prop]] = true && preValue.push(item));
          return preValue;
        }, []);
      },
      // 选择招聘顾问
      partnerSelChange(val) {
        this.memberQuery.StradviseruserId = val.value;
        this.memberQuery.StradviseruserName = val.label;
      },
      // 添加招聘顾问/部门
      addDepHandle() {
        if (this.isNullDate(this.perDepartList)) {
          this.$message.warning("请选择招聘部门");
          return false;
        } else {
          if (this.isNullDate(this.memberQuery.StradviseruserName)) {
            this.$message.warning("请选择主招招聘顾问");
            return false;
          }
          this.depUserList.push({
            Strorgancode: this.depUserQuery.Strorgancode, // 部门id
            StradviseruserId: this.memberQuery.StradviseruserId, // 招聘顾问id
            StradviseruserName: this.memberQuery.StradviseruserName, // 招聘顾问姓名
            StrIsshield: this.depUserQuery.checked ? "是" : "否", // 是否需要屏蔽 是或者否
            checked: this.depUserQuery.checked,
            StrRemark: "", // 备注（目前无）
          });
        }
      },
      // 删除数据
      dltDAtaHandle(data, index, item) {
        // console.log('kkk',item)
        let that = this;
        // let ckeck01 = that.perDepartList;
        data.splice(index, 1);
        // 包括其他部门人员也删掉该数据（所有部门人员）
        // that.depDiaAllUserList = that.depDiaAllUserList.filter(el => {
        //   if(!that.isNullDate(el.StradviseruserId)){
        //     if(!that.isNullDate(item.StradviseruserId)){
        //       return item.StradviseruserId != el.StradviseruserId;
        //     }else{
        //       return item.Strorgancode != el.Strorgancode;
        //     }
        //   }else{
        //     if(!that.isNullDate(item.StradviseruserId)){
        //       return item.StradviseruserId != el.StradviseruserId;
        //     }else{
        //       return item.Strorgancode != el.Strorgancode;
        //     }
        //   }
        // });
        // console.log('kkk',this.depDiaAllUserList)
        // // 同时选中的也去掉
        // if(!this.isNullDate(ckeck01)){
        //   for (let i = 0; i < that.perDepartList.length; i++) {
        //     let chkelement = that.perDepartList[i];
        //       if(!this.isNullDate(item.StradviseruserId)){
        //         if(chkelement[chkelement.length-1] == item.StradviseruserId){
        //           that.perDepartList.splice(i, 1);
        //         }
        //       }else if(!this.isNullDate(item.Strorgancode)){
        //         if(chkelement[chkelement.length-1] == item.Strorgancode){
        //           that.perDepartList.splice(i, 1);
        //         }
        //       }
        //   }
        // }
        // this.modalKey++;
      },
      confirmDistribution() {
        let that = this;
        // 原所有包括其他部门人员过滤出已删除的部门人员
        // this.allUserList = this.depDiaAllUserList.concat(this.diaUserList);
        this.allUserList = this.depDiaUserList.concat(this.diaUserList);
        if (this.isNullDate(that.allUserList)) {
          this.$message.warning("请选择分配部门");
          return false;
        }
        // 分配去重
        this.allUserList = this.allUserList.filter(function (item, index, self) {
          if (!that.isNullDate(item.StradviseruserId)) {
            return (
              self.indexOf(
                (el) => el.StradviseruserId == item.StradviseruserId
              ) == -1
            );
          } else {
            return (
              self.indexOf((el) => el.Strorgancode == item.Strorgancode) == -1
            );
          }
        });
        // console.log('11',that.diaUserList)
        for (let i = 0; i < this.allUserList.length; i++) {
          const elementdia = this.allUserList[i];
          if (elementdia.checked == true) {
            elementdia.StrIsshield = "是";
          } else {
            elementdia.StrIsshield = "否";
          }
        }
        let jsonstr = {
          GdrecpId: this.row.GdrecpId,
        };
        // console.log('hh',this.allUserList,this.depDiaUserList,'kk',this.diaUserList)
        xz.saveJbBusiRecruitPlandepuser(jsonstr, this.allUserList).then((res) => {
          if (res.status == "ok") {
            this.$message({
              message: "分配成功",
              type: "success",
            });
            this.searchRecruitmentneed();
            this.visibleDistribution = false;
          } else {
            this.$message.error("保存失败");
          }
        });
      },
      seach() {
        this.getNum();
        this.searchRecruitmentneed();
      },
      //表头样式
      headStyle(row, rowIndex) {
        let topstyle = {
          background: "#F3F4F7",
          color: "#555",
          "font-weight": "600",
        };
        let topstyle1 = {
          background: "oldlace",
          color: "#555",
          "font-weight": "600",
        };
        let topstyle2 = {
          background: "#D2DBF8",
          color: "#555",
          "font-weight": "600",
        };
        let topstyle3 = {
          background: "rgb(255, 199, 206)",
          color: "#555",
          "font-weight": "600",
        };
        let topstyle4 = {
          background: "#F0F9EB",
          color: "#555",
          "font-weight": "600",
        };
        let style1 = {
          background: "oldlace",
        };
        let style2 = {
          background: "#D2DBF8",
        };
        let style3 = {
          background: "rgb(255, 199, 206)",
        };
        let style4 = {
          background: "#F0F9EB",
        };
        // let style4 = { background: '#40DFFF' };
        if (row.column.level == 1) {
          if (row.column.label == "岗位信息") {
            return topstyle1;
          } else if (row.column.label == "待遇信息") {
            return topstyle2;
          } else if (row.column.label == "面试信息") {
            return topstyle3;
          } else if (row.column.label == "面试日期") {
            return topstyle4;
          } else {
            return topstyle;
          }
        }
        if (
          row.column.label == "岗位类型" ||
          row.column.label == "城市" ||
          row.column.label == "需求人数" ||
          row.column.label == "最新缺口" ||
          row.column.label == "性别" ||
          row.column.label == "年龄" ||
          row.column.label == "薪资"
        ) {
          return style1;
        } else if (
          row.column.label == "有社保" ||
          row.column.label == "有社保公积金" ||
          row.column.label == "是否包食" ||
          row.column.label == "是否包住" ||
          row.column.label == "有无押金" ||
          row.column.label == "是否加班" ||
          row.column.label == "是否倒班" ||
          row.column.label == "排班周期" ||
          row.column.label == "作息时间"
        ) {
          return style2;
        } else if (
          row.column.label == "客服/运营" ||
          row.column.label == "运营负责人" ||
          row.column.label == "招聘时限" ||
          row.column.label == "状态状态" ||
          row.column.label == "面试地点"
        ) {
          return style3;
        } else if (row.column.label.indexOf("-") == 4) {
          return style4;
        }
      },
      tableCellClassName(row) {
        if (row.column.label && row.column.label != null) {
          if (row.column.label.indexOf("-") == 4) {
            if (row.row[row.column.label]) {
              return "hasInter-row";
            }
          }
        }
      },
    },
  };
</script>

<style scoped>
  .recruitTable {
    background: #fff;
  }

  .empty {
    padding: 10px 20px;
    font-size: 14px;
  }

  .talkBox {
    background: #fff;
  }

  .bulletinBoard {
    margin: 5px 10px;
    border: 1px solid #767676;
    /* height: 80px; */
    width: 100%;
    padding: 5px;
  }

  .infoBox {
    /* max-height: 180px; */
    height: 50px;
    overflow: hidden;
  }

  .infoBox.infoBox_all {
    height: auto;
  }

  .uploadbox {
    margin: 10px 0 0 80px;
  }

  .talkTitle {
    overflow-wrap: break-word;
    text-transform: none;
    font-family: "微软雅黑 Bold", 微软雅黑, sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 12px;
    color: rgb(0, 0, 0);
    text-align: center;
    margin-left: 10px;
  }

  .talkinfo {
    display: -webkit-box;
    width: 100%;
    height: 40px;
    line-height: 20px;
    padding-left: 5px;
    font-family: "微软雅黑", sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: #0d0d0d;
    text-overflow: -o-ellipsis-lastline;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .page_recruitDemand .talkinfo_all {
    display: block;
    height: auto;
    text-overflow: unset;
    -webkit-line-clamp: unset;
    -webkit-box-orient: unset;
  }

  .talkTime {
    color: #999999;
    font-size: 12px;
  }

  .talkinfo span {
    margin-right: 10px;
    line-height: 20px;
  }

  .talkinfo img {
    width: 18px;
    height: 20px;
    vertical-align: bottom;
  }

  .talkinfo_box {
    width: 80%;
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
  }

  .talkinfo_right {
    display: flex;
    align-items: flex-end;
    width: 50px;
    font-size: 12px;
    margin-left: 8px;
    color: rgb(51, 153, 255);
    cursor: pointer;
  }

  .file {
    margin-left: 15px;
  }

  .moreBtn {
    padding-left: 10px;
  }

  .tableBtn span {
    font-family: 微软雅黑, sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 12px;
    color: rgb(51, 153, 255);
    text-align: center;
    cursor: pointer;
    margin-right: 5px;
    min-width: 28px;
    white-space: nowrap;
  }

  .fontBtn {
    margin-left: 10px;
    line-height: 40px;
    font-family: 微软雅黑, sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 12px;
    color: rgb(51, 153, 255);
    text-align: center;
    cursor: pointer;
    margin-right: 5px;
  }

  .moreBtn span {
    line-height: 48px;
    font-family: 微软雅黑, sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 12px;
    color: rgb(51, 153, 255);
    text-align: center;
    margin-right: 20px;
    cursor: pointer;
  }

  .recruitTop {
    /* height: 50px; */
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #d2ded9;
    display: flex;
    align-items: center;
  }

  .ftabs {
    background: #fff;
    width: 99%;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .pro_down_form {
    margin-top: 8px;
  }

  .talktitle {
    min-width: 80px;
  }

  .showMoreHead {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
  }

  .showMoreHead i {
    font-size: 22px;
    color: #19bd92;
    margin-left: 5px;
  }

  .dialogtitle {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
  }

  .p_plan_form01 {
    margin-top: 10px;
  }

  .plan_form_list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    max-height: 300px;
    overflow-y: auto;
  }

  .plan_form_list .p_plan_item {
    margin-right: 20px;
    margin-bottom: 10px;
  }

  .p_plan_title {
    margin-right: 12px;
  }

  .note_form:before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
  }

  .p_plan_right {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  .p_plan_record {
    width: 100%;
    font-size: 14px;
    color: #333;
    margin-bottom: 10px;
  }

  .p_plan_item {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    font-size: 14px;
  }

  .p_plan_form03 {
    margin-top: 10px;
  }
</style>

<style>
  .recruitTop .el-input .el-input__inner,
  .recruitTop .screenInput .el-select .el-input__inner {
    height: 32px;
    line-height: 32px;
    width: 150px;
  }

  .talkTop .el-select .el-input__inner {
    height: 28px;
    line-height: 28px;
    width: 150px;
  }

  .talkTop .el-input__icon {
    height: 28px;
    line-height: 28px;
  }

  .recruitTop .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 150px;
  }

  .recruitTop .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .recruitTop .el-form-item {
    margin-bottom: 5px;
  }

  .page_recruitDemand .el-dialog__body {
    padding: 0 40px 30px 30px;
  }

  .page_recruitDemand .recruitInputs .el-input {
    width: 94%;
  }

  .page_recruitDemand .ftabs .el-tabs__header {
    margin: 0;
  }

  .page_recruitDemand .pro_down_form .el-cascader,
  .pro_down_form .el-date-editor.el-input,
  .page_recruitDemand .pro_down_form.el-form--inline .el-form-item__content,
  .page_recruitDemand .pro_down_form .el-select {
    width: 150px;
  }

  .p_plan_form01 .el-cascader {
    width: 530px;
  }

  .plan_input02.el-select {
    width: 300px;
    margin-right: 10px;
  }

  .recruitTable .el-table--enable-row-transition .el-table__body td.el-table__cell {
    padding: 0;
    height: 48px;
    line-height: 48px;
    font-size: 12px;
  }

  .recruitTable .el-table th.el-table__cell>.cell {
    padding-left: 0px;
    padding-right: 0px;
    min-height: 23px;
  }

  .recruitTable .el-table .cell {
    padding-left: 4px;
    padding-right: 4px;
    min-height: 48px;
    padding-right: 10px;
    display: flex;
    align-items: center;
  }

  .recruitTable .el-table .hasInter-row {
    background: #f0f9eb !important;
    /* font-weight: 600; */
  }

  .badge .el-badge__content.is-fixed {
    top: 3px;
    right: 3px;
  }

  /* .badge .el-badge{
  max-width: 95px;
  min-height: 48px;
  display: flex;
  align-items: center;
} */
</style>